// App.jsx
import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from '../Layout/Layout';

import HomePage from '../../pages/HomePage/HomePage';
import BlogPage from '../../pages/BlogPage/BlogPage';
import BlogArticleDetails from '../../pages/BlogArticleDetails/BlogArticleDetails';
import AdminPage from '../../pages/AdminPage/AdminPage';
import Dashboard from '../admin/Dashboard/Dashboard';
import PostsList from '../admin/PostsList/PostsList';
import PostCreate from '../admin/PostCreate/PostCreate';
import ProjectCreate from '../admin/ProjectCreate/ProjectCreate';
import ProjectList from '../admin/ProjectList/ProjectList';

const App = () => {
  return (
    <Routes>
      {/* Layout-обгортка */}
      <Route path="/" element={<Layout />}>
        {/* EN (без префікса) */}
        <Route index element={<HomePage />} />
        <Route path="blog" element={<BlogPage />} />

        {/* УНІФІКОВАНИЙ маршрут статті для EN: тепер теж зі slug */}
        <Route path="blog/post/:slug/:id" element={<BlogArticleDetails />} />

        {/* Тимчасова сумісність зі старим EN-маршрутом без slug
            (компонент сам зробить replace на канонічний URL зі slug) */}
        <Route path="blog/post/:id" element={<BlogArticleDetails />} />

        {/* Гілка з мовним префіксом для інших мов */}
        <Route path=":lang">
          <Route index element={<HomePage />} />
          <Route path="blog" element={<BlogPage />} />

          {/* ВАЖЛИВО: відносний шлях без початкового "/" */}
          <Route path="blog/post/:slug/:id" element={<BlogArticleDetails />} />
        </Route>

        {/* Фолбек на корінь */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>

      {/* Admin Page */}
      <Route path="/admin" element={<AdminPage />}>
        <Route index element={<Dashboard />} />
        <Route path="posts" element={<PostsList />} />
        <Route path="posts/new" element={<PostCreate />} />
        <Route path="projects/new" element={<ProjectCreate />} />
        <Route path="projects" element={<ProjectList />} />
      </Route>
    </Routes>
  );
};

export default App;
